import api, { cardeal } from './api';

export class SimularBeneficioService {
  getSimularBeneficioParticipante = async (values, matricula) => {
    const result = await cardeal
      .post('SimularBeneficioParticipante', {
        matricula: String(matricula),
        valorSalario: values.remuneracaoMensal,
        percentualContribuicao: values.percentualContribuicao,
        retornoRealInvestimento: values.retornoInvestimento,
        crescimentoRealSalario: values.crescimentoSalario,
        tempoBeneficioEmMeses: values.mesesAposentar,
        quantidadeEstimadaRemuneracoesPr: values.remuneracoesAno,
        percentualSaque: values.percentualSaque,
        opcaoRenda: values.tipoRendaMensal,
        prazoRendaTemporaria: values.prazoRendaTemporaria,
        percentualRcm: values.percentualrcm,
        percentualRenda: values.percentualSaldoVitalicio,
        percentualSaldo: values.percentualRendaMensal,
        codigosBeneficiario: values.codigosBeneficiario,
      })
      .then((res) => {
        return res.data.SimularBeneficioParticipanteResult;
      })
      .catch((err) => {
        console.error(`Houve um erro ${err}`);
      });
    return result;
  };

  obterRelatorioResultadoSimulacao = async (
    values,
    matricula,
    token,
    beneficiarios
  ) => {
    const result = await api
      .post('GerarPdfSimulacaoBeneficio', {
        matricula: String(matricula),
        token,
        valorSalario: values.remuneracaoMensal,
        percentualContribuicao: values.percentualContribuicao,
        retornoRealInvestimento: values.retornoInvestimento,
        crescimentoRealSalario: values.crescimentoSalario,
        tempoBeneficioEmMeses: values.mesesAposentar,
        quantidadeEstimadaRemuneracoesPr: values.remuneracoesAno,
        percentualSaque: values.percentualSaque,
        opcaoRenda: values.tipoRendaMensal,
        prazoRendaTemporaria: values.prazoRendaTemporaria,
        percentualRcm: values.percentualrcm,
        percentualRenda: values.percentualSaldoVitalicio,
        percentualSaldo: values.percentualRendaMensal,
        codigosBeneficiario: beneficiarios,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error(`Houve um erro ${err}`);
      });
    return result;
  };

  postConversaoParticipante = async (values) => {
    const percentualSaldo =
      values.percentualSaldo === '' ? 0 : values.percentualSaldo;

    const percentualRendaVitalicia =
      values.percentualRendaVitalicia === ''
        ? 0
        : values.percentualRendaVitalicia;

    const result = await cardeal.post('SimularConversaoParticipante', {
      matricula: values.matricula,
      opcaoRenda: values.opcaoRenda,
      percentualSaldo,
      percentualRcm: values.percentualRcm,
      percentualRendaVitalicia,
      codigosBeneficiario: values.codigosBeneficiario,
    });

    return result.data.SimularOpcaoTrocaRendaParticipanteResult;
  };

  postLinkConversaoBeneficios = async (values) => {
    const percentualSaldo =
      values.percentualSaldo === '' ? 0 : values.percentualSaldo;

    const percentualRendaVitalicia =
      values.percentualRendaVitalicia === ''
        ? 0
        : values.percentualRendaVitalicia;

    const result = await api.post('GerarPDFConversaoBeneficio', {
      matricula: values.matricula,
      nome: values.nome,
      token: values.token,
      idade: values.idade,
      opcaoRenda: values.opcaoRenda,
      percentualSaldo,
      percentualRcm: values.percentualRcm,
      percentualRendaVitalicia,
      codigosBeneficiario: values.codigosBeneficiario,
      beneficiarios: values.beneficiarios,
    });

    return result.data;
  };

  getPercentualRCM = async (matricula) => {
    const response = await cardeal.get('ObterPercentualRCM', {
      params: {
        matricula,
      },
    });

    if (response.data.ObterPercentualRCMResult.Value === '0') return 0;
    return parseInt(response.data.ObterPercentualRCMResult.Value, 10);
  };

  getCompatibilidadeConversao = async (matricula) => {
    const response = await cardeal.get('VerificarCompatibilidadeConversao', {
      params: {
        matricula,
      },
    });
    if (response.data.ObterCompatibilidadeSimulacaoRendaResult.Key === 'S')
      return true;

    return false;
  };

  getProporcionalidadeConversao = async (matricula) => {
    const response = await cardeal.get('ObterProporcionalidadeConversao', {
      params: {
        matricula,
      },
    });

    return response.data
      .ProporcionalidadeConversaoRendaCertaParaIndeterminadaResult;
  };

  getVerificacaoRendaConjugada = async (matricula) => {
    const response = await cardeal.get('VerificarRendaConjugada', {
      params: {
        matricula,
      },
    });
    return response.data;
  };
}
